<template>
  <DropdownMenu
    :dropped.sync="isDropped"
    :stylings="{
      labelButtonClass:
        'AssetTableNotes__label btn btn-link btn-lg opacity-75 px-1 ' +
        (asset.notes && asset.notes.length > 0 ? 'text-warning' : 'text-info'),
    }"
    class="AssetTableNotes"
  >
    <span slot="icon"><span class="fa fa-sticky-note"></span></span>
    <div
      slot="dropdown"
      class="AssetTableNotes__List"
      :class="{ 'AssetTableNotes__List-landscape': isLandscape }"
    >
      <form class="" @submit.prevent="updateAssetAndRedirect">
        <b-form-group
          class="mb-1"
          :label="
            label ||
            $t('edit_asset_page.notes_label', {
              assetName: asset.name,
              assetSymbol: asset.symbol,
            })
          "
        >
          <b-form-textarea
            aria-describedby="transaction_notes-help"
            v-model="notes"
            :state="isValid ? null : false"
            ref="input"
            rows="3"
            max-rows="6"
            :placeholder="
              isFocused
                ? ''
                : placeholder || $t('edit_asset_page.notes_placeholder')
            "
            @focus="isFocused = true"
            @blur="isFocused = false"
          ></b-form-textarea>
          <b-form-text
            id="transaction_notes-help"
            class="text-right"
            :text-variant="isValid ? 'muted' : 'danger'"
          >
            {{ (notes || "").length + "/" + notesMaxLength }}
          </b-form-text>
        </b-form-group>

        <b-button variant="primary" type="submit" size="sm">
          <i class="fa fa-check mr-1"></i>{{ $t("edit_asset_page.save") }}
        </b-button>
      </form>
    </div>
  </DropdownMenu>
</template>

<script>
import DropdownMenu from "./DropdownMenu.vue";
import options from "@/options";

export default {
  name: "AssetTableNotes",
  components: {
    DropdownMenu,
  },
  props: {
    asset: Object,
    isLandscape: Boolean,
    updateAsset: Function,
    label: { type: String },
    placeholder: { type: String },
  },
  data() {
    return {
      isDropped: false,
      isFocused: false,
      notes: this.asset.notes,
    };
  },
  computed: {
    isValid() {
      return (this.notes || "").length <= this.notesMaxLength;
    },
  },
  watch: {
    "asset.notes"() {
      this.notes = this.asset.notes;
    },
  },
  methods: {
    updateAssetAndRedirect() {
      if (!this.isValid) {
        return;
      }
      const { asset } = this;
      this.isDropped = false;
      const assetData = {
        id: asset.id,
        exchId: asset.exchId,
        currencyId: asset.currencyId,
        notes: this.notes || null,
      };
      this.updateAsset(assetData);
    },
  },
  created() {
    this.notesMaxLength = options.notesMaxLength;
  },
};
</script>

<style lang="scss">
@import "~@/scss/mixins";
@import "~@/scss/variables";

.AssetTableNotes {
  margin-left: auto;
  margin-right: auto;
}
.AssetTableNotes__label {
  font-size: 1.175rem;
}
.AssetTableNotes__List {
  min-width: 575px;
  padding: 5px 10px;

  @include breakpoint-manual(max-width, $break-large - 1px) {
    min-width: 280px;
  }
}
.AssetTableNotes__List-landscape {
  min-width: 400px;
}
</style>
